import { render, staticRenderFns } from "./_memberSosClickLog.vue?vue&type=template&id=529fbd7a&lang=pug"
import script from "./_memberSosClickLog.vue?vue&type=script&lang=js"
export * from "./_memberSosClickLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports